<template>
    <div id="main" v-if="loaded">
        <header id="header">
            <!-- <navigationMenu v-if="authenticated" :authenticated="authenticated" :user="user" @signOut="signOut"></navigationMenu> -->
            <navigationMenu v-if="authenticated" @signOut="signOut"></navigationMenu>
        </header>
        <div id="content">
            <div id="alert" v-if="alert.show && currentRoute != 'CustomerSignUp'">
                <b-alert class="alert-warning-bar" show variant="warning">New version available. Please save your work before clicking update! <b-link href="#" @click="$router.go(); alert.show = false" class="alert-link">UPDATE</b-link></b-alert>
            </div>

            <div v-if="authenticated || currentRoute == 'CustomerSignUp'">
                <router-view></router-view>
            </div>
            <div v-else>
                <reset-password v-if="$route.path.match('/passwordreset')" />
                <sign-in v-else />
            </div>
        </div>
    </div>
</template>
<script>
    import SignIn from './pages/SignIn'
    import ResetPassword from './pages/ResetPassword'
    import navigationMenu from './components/Menu'
    import { AbilityBuilder } from '@casl/ability'
    // import { mapGetters, mapActions, mapMutations } from 'vuex'
    export default {
        data() {
            return {
                currentRoute: '',
                alert: {
                    show: false
                },
                loaded: 0
            }
        },

        computed: {
  			// ...mapGetters({
    		// 	authenticated: 'auth/authenticated',
    		// 	user: 'auth/user',
            //     abilities: 'auth/abilities',
            //     // env: 'env/getEnv',
            //     // locations: 'locations/getLocations'
  			// })
		},

        components: {
            SignIn,
            ResetPassword,
            navigationMenu
        },

        methods: {
        	// ...mapActions({
        	// 	signOutAction: 'auth/signOut'
      		// }),

            // ...mapMutations({
            //     setAbility: 'auth/SET_ABILITIES',
            //     setEnv: 'env/SET_ENV',
            //     setLocations: 'locations/SET_LOCATIONS'

            // }),

            updateAbility(abilities) {
                const { can, rules } = new AbilityBuilder()

                let obj = abilities
                obj.forEach(element => {
                    can(element.name, '')
                })

                this.$ability.update(rules)
            },

      		async signOut () {
                Echo.leaveChannel('table-item-updated')
        		await this.signOutAction()
      		},

            processAbilities(resync) {
                if (resync) {
                    axios.get('/api/user/permissions').then((response) => {
                        this.setAbility(response.data)
                        this.updateAbility(this.abilities)
                    })
                } else {
                    this.updateAbility(this.abilities)
                }

                // let routeCheck = this.$router.resolve({path: window.location.pathname})
                // if ((window.location.pathname != '/' && routeCheck) && window.location.pathname != this.$router.currentRoute.path) {
                //     this.$router.push({ name: routeCheck.route.name })
                // }
            },

            getEnv() {
                let url = 'api/getenv'
                axios.get(url, {})
                .then((res) => {
                    this.setEnv(res.data)
                }, () => {
                    this.has_error = true
                })
            },

            async getLoc() {
                let url = 'api/getlocations'
                axios.get(url, {})
                .then((res) => {
                    this.setLocations(res.data)
                }, () => {
                    this.has_error = true
                })
                .finally(() => {
                    this.loaded = 1
                })
            }
        },

        async mounted() {
            this.currentRoute = this.$router.currentRoute.name
            this.processAbilities()
            this.getEnv()
            this.getLoc()

            // pusher
            Echo.channel('users-abilities-updated')
                .listen('UsersAbilitiesUpdated', (e) => {
                    this.processAbilities(1)
            })

            Echo.channel('repo-updated')
                .listen('RepoUpdated', (e) => {
                    if (this.authenticated) {
                        this.alert.show = true
                    } else {
                        this.$router.go()
                    }
            })
        }
    }
</script>
<style lang="scss">
    img[src=''] {
        display: none;
    }

    .icon-danger i {
            color: red;
    }

	#main {
		#content {
			margin-top: 66px;

            .page-title {
                h3 {
                    font-size: 1.25rem;
                    text-transform: uppercase;
                    padding-top: 5px;
                }
            }
		}
	}

    .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
        color: #495057;
        background-color: #fff;
        border-color: #a1cbef;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(52, 144, 220, 0.25);
    }

    .was-validated .form-control:valid, .form-control.is-valid {
        border-color: #DDD;
        background-image: none;
    }
</style>
